import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RightClickMenuComponent } from './right-click-menu.component';

@NgModule({
  declarations: [RightClickMenuComponent],
  imports: [CommonModule],
  exports: [RightClickMenuComponent]
})
export class RightClickMenuModule { }